import {
  PARSE_DYNAMIC_TAB_TITLE
} from './actionTypes';
import { createAction } from '../utils/createAction';

export const updateDynamicTabTitle = createAction(PARSE_DYNAMIC_TAB_TITLE, 'dynamicTabTitle');

